module.exports = __webpack_public_path__ + "static/media/talk_about_education.010cf3ce.mp4";